import getCurrentVariantProductSelect from 'modules/product/redux/selectors/get-current-variant'
import { shouldShowAOVLockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-lock'
import { shouldShowAOVUnlockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-unlock'

export const getClassNameToAddSidebarContentSelect = state => {
  /**
   * @type {ProductVariantCollection}
   */
  const productVariant = getCurrentVariantProductSelect(state)
  const shouldShowAovLock = shouldShowAOVLockProductVariantSelector({
    productVariant
  })(state)

  const shouldShowAovUnlock = shouldShowAOVUnlockProductVariantSelector({
    productVariant
  })(state)

  if (shouldShowAovLock) {
    return 'sidebar-content_with-aov-lock'
  }

  if (shouldShowAovUnlock) {
    return 'sidebar-content_with-aov-unlock'
  }

  return ''
}
